import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';





const FeatureFive = () => {
    const { t } = useTranslation();
    const featureContent = [
        {
            img: 'icon-37c',
            title: t('block11'),
            desc: t('block12'),
            dataAos:'fade-up',
            dataDelay: ''
        },
        {
            img: 'icon-33c',
            title: t('block13'),
            desc: t('block14'),
            dataAos:'fade-up',
            dataDelay: '100'
        },
        {
            img: 'icon-35c',
            title: t('block15'),
            desc: t('block16'),
            dataAos:'fade-up',
            dataDelay: '200'
        },
        {
            img: 'icon-34c',
            title: t('block21'),
            desc: t('block22'),
            dataAos:'fade-up',
            dataDelay: '250'
        },
        {
            img: 'icon-36c',
            title: t('block17'),
            desc: t('block18'),
            dataAos:'fade-up',
            dataDelay: '300'
        },
        {
            img: 'icon-38c',
            title: t('block19'),
            desc: t('block20'),
            dataAos:'fade-up',
            dataDelay: '350'
        },
    ]


    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5">
                {featureContent.map((val, i)=>(
                    <div key={i} className="col-lg-4 col-md-6" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                        <div className="feature-style-five mb-45">
                            <div className="icon mb-30">
                                <img src={`assets/img/icon/${val.img}.svg`}alt="icon"/>
                            </div>
                            <h2 className="mb-20">
                                <Link className="sect-title-two" >{val.title}</Link>
                            </h2>
                            <p>{val.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default FeatureFive